import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const ObligationCreation = (): unknown => {
    return import(/* webpackPrefetch: true */ './obligation-creation-page.vue');
};

export const obligationCreationRoute: RouteRecordRaw = {
    ...ROUTE_DATA.OBLIGATION_CREATION_PAGE,
    components: {
        main: ObligationCreation
    },

    props: {
        main(route: RouteLocation): { agreementId?: number } {
            return {
                agreementId: routerHelper.parseParamToInt(route.params.id as string)
            };
        }
    }
};

export const obligationEditionRoute: RouteRecordRaw = {
    ...ROUTE_DATA.OBLIGATION_EDITION_PAGE,
    components: {
        main: ObligationCreation
    },

    props: {
        main(route: RouteLocation): { agreementId?: number; obligationId?: number } {
            return {
                agreementId: routerHelper.parseParamToInt(route.params.agreementId as string),
                obligationId: routerHelper.parseParamToInt(route.params.obligationId as string)
            };
        }
    }
};
